import { MailPlus } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { IAM_PERMISSIONS } from '@/lib/permissions'

import { acceptInviteRoute, entityInvitationsRoute, sendInviteRoute } from './routes'

export const invitationsModule = defineModule({
  routes: [acceptInviteRoute, entityInvitationsRoute, sendInviteRoute],
  navigation: {
    admin: [
      {
        to: '/$entityId/invitations',
        label: 'Invitations',
        icon: MailPlus,
        permission: IAM_PERMISSIONS.manage,
        section: 'access',
        order: 20,
      },
    ],
  },
})
